import React, { useContext, useState } from 'react';
import ReactModal from 'react-modal';
import { browserVersion, isMobile } from 'react-device-detect';

import { Loading } from '../../components';
import { FeatureGatingContext, UserContext } from '../../contexts';
import { featureTypes } from '../../contexts/FeatureGating';
import { useMerchantStripe } from '../useMerchantStripe';

import './feature-gating-popup.scss';

export function FeatureGatingPopup() {
  const { user, token } = useContext(UserContext);
  const { showFeatureGatingModal, setShowFeatureGatingModal } = useContext(FeatureGatingContext);
  const { goToStripeManagementPage } = useMerchantStripe();
  const [going, setGoing] = useState(false);

  const goToManagement = async () => {
    setGoing(true);
    await goToStripeManagementPage(user, token, true);
    setGoing(false);
    setShowFeatureGatingModal(false);
  }

  return (
    <ReactModal
      {...{
        isOpen: !!showFeatureGatingModal,
        onRequestClose: () => setShowFeatureGatingModal(false),
        className:`feature-gating-modal ${(browserVersion < 15 && !isMobile) ? 'old-mac-product-preview-modal' : ''}`
      }}
    >
      <div className="content">
        <div className="title">
          {
            showFeatureGatingModal === featureTypes.AMOUNT
              ? "You’ve reached the monthly limit for this feature on your current plan"
              : "This feature is unavailable on your current plan, upgrade to unlock premium benefits"
          }
        </div>

        <div className="buttons">
          <button onClick={() => setShowFeatureGatingModal(false)}>Close</button>
          <button onClick={() => goToManagement()}>
            {going && (
              <Loading />
            )}
            Upgrade
          </button>
        </div>

        <div className="learn">
          Learn more about the features at&nbsp;
          <a target="_blank" href="https://www.retail-circle.io/membership">https://www.retail-circle.io/membership</a>
        </div>
      </div>
    </ReactModal>
  );
}
